import { FullStackElementOption } from "@hub/models/content/full-stack-element-tree";
import Image from "next/legacy/image";
import React from "react";
import styles from "./full-stack-option-button.module.css";
import Link from "next/link";

interface FullStackOptionButtonProps {
  option: FullStackElementOption;
  onClick: () => void;
  isActive: boolean;
  compact?: boolean;
  path?: string;
}

export const FullStackOptionButton: React.FC<FullStackOptionButtonProps> = ({
  option,
  onClick,
  isActive,
  compact = false,
  path,
}) => {
  const { name, icon } = option;

  if (path) {
    if (compact) {
      return (
        <Link
          href={path}
          className={`${styles.fullStackOptionButton} ${
            styles.fullStackOptionButton__compact
          } ${isActive ? styles.fullStackOptionButton__active : ""}`}
          onClick={onClick}
        >
          <div className={styles.fullStackOptionButton__label}>{name}</div>
        </Link>
      );
    }

    return (
      <Link
        href={path}
        className={`${styles.fullStackOptionButton} ${
          isActive ? styles.fullStackOptionButton__active : ""
        }`}
      >
        {icon && (
          <div className={styles.fullStackOptionButton__icon}>
            <Image
              src={icon}
              layout="fixed"
              height={48}
              width={48}
              alt={`${name} logo`}
            />
          </div>
        )}
        <div className={styles.fullStackOptionButton__label}>{name}</div>
      </Link>
    );
  }

  if (compact) {
    return (
      <div
        className={`${styles.fullStackOptionButton} ${
          styles.fullStackOptionButton__compact
        } ${isActive ? styles.fullStackOptionButton__active : ""}`}
        onClick={onClick}
      >
        <div className={styles.fullStackOptionButton__label}>{name}</div>
      </div>
    );
  }

  return (
    <div
      className={`${styles.fullStackOptionButton} ${
        isActive ? styles.fullStackOptionButton__active : ""
      }`}
      onClick={onClick}
    >
      {icon && (
        <div className={styles.fullStackOptionButton__icon}>
          <Image
            src={icon}
            layout="fixed"
            height={48}
            width={48}
            alt={`${name} logo`}
          />
        </div>
      )}
      <div className={styles.fullStackOptionButton__label}>{name}</div>
    </div>
  );
};
